<template>
	<div class="media" style="display:block;">
		<img :src="appweb.sponsor" />
	</div>
</template>
<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
export default {
	name: "meidaPartners",
	data() {
		return {};
	},
	mounted() {},
	methods: {},
	computed: {
		...mapState(["appweb"])
	}
};
</script>
<style scoped>
img {
	width: 100%;
	margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/xd-mediaPartner.vue